import React, { useEffect, useState } from 'react';
import { authGet } from '../utils/authCalls';
import { Modal } from 'antd';
import TopInfoBanner from './TopInfoBanner';
import PaymentForm from './onBoarding/PaymentForm';
import { useSuspenseQuery } from '@tanstack/react-query';
import { invoicesQueryOptions, subscriptionQueryOptions } from '../utils/queryOptions';
import { useNavigate } from '@tanstack/react-router';
import { apiV1 } from '../utils/apiClient';
import { Invoice } from '@next-is-free-monorepo/next-is-free-types';

const SubscriptionCheckBanner = () => {
  const [loading, setLoading] = useState(false);
  const subscription = useSuspenseQuery(subscriptionQueryOptions());
  const invoices = useSuspenseQuery(invoicesQueryOptions());
  const navigate = useNavigate();

  //if subscription status is incomplete it means the subscription has just been created
  //but the payment is not completed so user is forced to pay or to cancel the subscription
  if (subscription.data.status === 'incomplete' || subscription.data.status === 'paused') {
    return (
      <Modal footer={''} styles={{
        mask: {
          backdropFilter: 'blur(5px)'
        }
      }} open closable={false}>
        <div>
          <h2 className={'text-center font-medium text-lg mb-4'}>Completa il pagamento per continuare</h2>
          <PaymentForm />
        </div>
      </Modal>
    );
  }

  //User Doesn't have any subscription
  if (!subscription.data.status) {
    return (
      <TopInfoBanner
        boldText={'Non hai un abbonamento attivo '}
        text={''}
        buttonText={'Abbonati ora'}
        onClick={() => navigate({ to: '/billings' })}
        buttonLoading={loading}
      />
    );
  }

  //user has an invoice that is past due, it's possible to still use the service but it needs to be payed
  if(invoices.data.some((invoice)=>invoice.status === 'open' && invoice.payment_intent?.status !== 'processing')){
    return (
      <TopInfoBanner
        boldText={''}
        text={'Hai una fattura non pagata. Ti invitiamo a saldarla il prima possibile per evitare l’interruzione del servizio.'}
        buttonText={'Paga ora'}
        onClick={() => navigate({ to: '/billings', hash: 'invoices' })}
        buttonLoading={loading}
      />
    );
  }

  //User doesn't have a payment method
 /* async function updatePaymentMethod() {
    const url = await apiV1.get<string>(`/shop/stripe-billing-portal?flow_data_type=payment_method_update`);
    window.location.replace(url);
  }

  if (!subscription.data.default_payment_method)
    return (
      <TopInfoBanner
        boldText={'Nessun metodo di pagamento '}
        text={', inserisci un metodo di pagamento valido'}
        buttonText={'Aggiungi metodo di pagamento'}
        onClick={() => {
          setLoading(true);
          updatePaymentMethod();
        }}
        buttonLoading={loading}
      />
    );
  else return null;*/
};
export default SubscriptionCheckBanner;
